// // src/components/HeroSection.js
// import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';
// import { FaPlay, FaPause, FaVolumeMute, FaVolumeUp } from 'react-icons/fa';

// const HeroSection = () => {
//   const [isMuted, setIsMuted] = useState(true);
//   const [isPlaying, setIsPlaying] = useState(true);
//   const [videoError, setVideoError] = useState(false);

//   // Video ref for play/pause control
//   const videoRef = React.useRef(null);

// const scrollToVideo = () => {
//   const section = document.getElementById("videosection");
//   if (section) {
//     section.scrollIntoView({ behavior: "smooth" });
//   }
// };

//   // Fallback image if video fails to load
//   const fallbackImage = "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772443394/WhatsApp_Image_2026-03-02_at_2.18.01_PM_rt5qhu.jpg";

//   return (
//     <section className="relative h-screen w-full overflow-hidden">
//       {/* Video Background */}
//       <div className="absolute inset-0 w-full h-full">
//         {!videoError ? (
//        <video
//   ref={videoRef}
//   autoPlay
//   loop
//   muted
//   playsInline
//   preload="auto"
//   className="absolute top-1/2 left-1/2 min-w-full min-h-full w-auto h-auto transform -translate-x-1/2 -translate-y-1/2 object-cover"
//   onError={() => setVideoError(true)}
// >
//   {/* Multiple formats for browser compatibility */}
//   <source src="https://res.cloudinary.com/dgwnm39m7/video/upload/v1772444885/clipfly-ai-20260302144305_1_sygqaz.mp4" type="video/mp4" />
//   <source src="https://res.cloudinary.com/dgwnm39m7/video/upload/v1772444885/clipfly-ai-20260302144305_1_sygqaz.mp4" type="video/webm" />
//   Your browser does not support the video tag.
// </video>
//         ) : (
//           <img 
//             src={fallbackImage}
//             alt="StayIN Luxury Apartments"
//             className="absolute top-1/2 left-1/2 min-w-full min-h-full w-auto h-auto transform -translate-x-1/2 -translate-y-1/2 object-cover"
//           />
//         )}

//         {/* Dark Overlay - Improves text readability */}
//         <div className="absolute inset-0 lg:bg-black/15 bg-black/50"></div>
        
//         {/* Gradient Overlay for smooth edges */}
//         {/* <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black/60"></div> */}
//       </div>

//       {/* Content Overlay */}
//       <div className="relative z-10 h-full flex items-center justify-center">
//         <div className="container-custom text-center text-white">
//           {/* Badge - Updated with Centaurus */}
//           <div className=" animate-fade-in-up">
//             <h2 className="inline-block  text-white px-4 2xl:py-2 py-1 rounded-full text-[22px] md:text-xl 2xl:text-3xl font-bold">
//               ✦ Discover Centaurus Hotel Service Appartments by StayIN ✦
//             </h2>
//           </div>

//           {/* Main Heading - Updated with new content */}
//           <h1 className="text-5xl md:text-7xl 2xl:text-8xl font-bold 2xl:mb-4 mb-2 animate-fade-in-up animation-delay-200">
//             <span className="block">A serene escape in the</span>
//             <span className="block text-[#c9a86c]">heart of Islamabad.</span>
//           </h1>

//           {/* Subheading - Updated with new content */}
//           <p className="text-xl md:text-2xl 2xl:mb-10 mb-4 max-w-3xl mx-auto text-gray-200 animate-fade-in-up animation-delay-400">
//             Experience elegance, comfort, and iconic views.
//           </p>

//           {/* Stats - Keep as is */}
//           {/* <div className="flex flex-wrap justify-center gap-8 mb-10 animate-fade-in-up animation-delay-600">
//             <div className="text-center">
//               <div className="text-3xl font-bold text-[#c9a86c]">500+</div>
//               <div className="text-sm uppercase tracking-wider">Happy Guests</div>
//             </div>
//             <div className="text-center">
//               <div className="text-3xl font-bold text-[#c9a86c]">3</div>
//               <div className="text-sm uppercase tracking-wider">Apartment Types</div>
//             </div>
//             <div className="text-center">
//               <div className="text-3xl font-bold text-[#c9a86c]">24/7</div>
//               <div className="text-sm uppercase tracking-wider">Concierge</div>
//             </div>
//           </div> */}

//           {/* CTA Buttons - Keep as is */}
//           <div className="flex flex-col sm:flex-row gap-4 justify-center animate-fade-in-up animation-delay-800">
          
//             <Link 
//               to="/apartments" 
//               className="bg-[#c9a86c] text-white px-8 py-4 rounded-full font-medium hover:bg-[#b38f5a] transition-all duration-300 inline-flex items-center gap-2 justify-center group"
//             >
//               <span>View Apartments</span>
//               {/* <span className="group-hover:translate-x-1 transition">→</span> */}
//             </Link>
//             {/* <Link 
//               to="/contact" 
//               className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-lg font-semibold hover:bg-white hover:text-[#1a2b3c] transition text-lg"
//             >
//               Schedule a Tour
//             </Link> */}
//           </div>
//         </div>
//       </div>

   

    
//     </section>
//   );
// };

// export default HeroSection;

// src/components/HeroSection.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from "react-helmet";
import { FaPlay, FaPause, FaVolumeMute, FaVolumeUp } from 'react-icons/fa';

const HeroSection = () => {
  const [isMuted, setIsMuted] = useState(true);
  const [isPlaying, setIsPlaying] = useState(true);
  const [videoError, setVideoError] = useState(false);

  // Video ref for play/pause control
  const videoRef = React.useRef(null);

  const scrollToVideo = () => {
    const section = document.getElementById("videosection");
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  // Fallback image if video fails to load
  const fallbackImage = "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772443394/WhatsApp_Image_2026-03-02_at_2.18.01_PM_rt5qhu.jpg";

  // SEO Data
  const seoData = {
    title: "Luxury Serviced Apartments in Centaurus Islamabad | StayIN Hospitality",
    description: "Experience 5-star luxury at StayIN's serviced apartments in Centaurus Islamabad. Enjoy panoramic city views, fully furnished suites with private kitchens, and 24/7 concierge. Book your premium stay today.",
    keywords: "Centaurus Hotel Islamabad, serviced apartments Islamabad, luxury apartments Centaurus, StayIN Centaurus, executive suites Islamabad, furnished apartments Islamabad",
    canonical: "https://stayinhospitality.com/",
    ogImage: "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772443394/WhatsApp_Image_2026-03-02_at_2.18.01_PM_rt5qhu.jpg",
  };

  // Enhanced Schema Markup for the Hero Section
  const schemaMarkup = {
    "@context": "https://schema.org",
    "@type": "Hotel",
    "name": "StayIN Centaurus Hotel Apartments",
    "description": "Luxury serviced apartments in The Centaurus Islamabad offering premium accommodations with panoramic city views and 5-star amenities.",
    "url": "https://stayinhospitality.com/",
    "image": seoData.ogImage,
    "priceRange": "₨₨₨₨",
    "telephone": "+92 303 4935404", 
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "The Centaurus, F-8",
      "addressLocality": "Islamabad",
      "addressRegion": "Islamabad Capital Territory",
      "postalCode": "44000",
      "addressCountry": "PK"
    },
    "amenityFeature": [
      {
        "@type": "LocationFeatureSpecification",
        "name": "Free High-Speed WiFi",
        "value": true
      },
      {
        "@type": "LocationFeatureSpecification",
        "name": "Free Parking",
        "value": true
      },
      {
        "@type": "LocationFeatureSpecification",
        "name": "Room Service",
        "value": true
      },
      {
        "@type": "LocationFeatureSpecification",
        "name": "Fitness Center",
        "value": true
      },
      {
        "@type": "LocationFeatureSpecification",
        "name": "Swimming Pool",
        "value": true
      }
    ],
    "starRating": {
      "@type": "Rating",
      "ratingValue": "5",
      "bestRating": "5"
    },
    "potentialAction": {
      "@type": "ReserveAction",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://stayinhospitality.com/apartments",
        "inLanguage": "en",
        "actionPlatform": [
          "http://schema.org/DesktopWebPlatform",
          "http://schema.org/MobileWebPlatform"
        ]
      },
      "name": "Book Now"
    }
  };

  return (
    <>
      {/* React Helmet for Meta Tags */}
      <Helmet>
        {/* Primary Meta Tags */}
        <title>{seoData.title}</title>
        <meta name="description" content={seoData.description} />
        <meta name="keywords" content={seoData.keywords} />
        
        {/* Canonical URL */}
        <link rel="canonical" href={seoData.canonical} />
        
        {/* Language and Region */}
        <meta property="og:locale" content="en_PK" />
        <meta property="og:site_name" content="StayIN Hospitality" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content={seoData.canonical} />
        <meta property="og:title" content={seoData.title} />
        <meta property="og:description" content={seoData.description} />
        <meta property="og:image" content={seoData.ogImage} />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:image:alt" content="Luxury Serviced Apartments in Centaurus Islamabad" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={seoData.title} />
        <meta name="twitter:description" content={seoData.description} />
        <meta name="twitter:image" content={seoData.ogImage} />
        
        {/* Additional SEO Meta Tags */}
        <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large" />
        <meta name="author" content="StayIN Hospitality" />
        <meta name="geo.region" content="PK-IS" />
        <meta name="geo.placename" content="Islamabad" />
        <meta name="geo.position" content="33.7330;73.0715" />
        <meta name="ICBM" content="33.7330, 73.0715" />
        
        {/* Schema Markup */}
        <script type="application/ld+json">
          {JSON.stringify(schemaMarkup)}
        </script>
      </Helmet>

      <section className="relative h-screen w-full overflow-hidden">
        {/* Video Background */}
        <div className="absolute inset-0 w-full h-full">
          {!videoError ? (
            <video
              ref={videoRef}
              autoPlay
              loop
              muted
              playsInline
              preload="auto"
              className="absolute top-1/2 left-1/2 min-w-full min-h-full w-auto h-auto transform -translate-x-1/2 -translate-y-1/2 object-cover"
              onError={() => setVideoError(true)}
              poster={fallbackImage} // Add poster for better loading experience
            >
              {/* Multiple formats for browser compatibility */}
              <source src="https://res.cloudinary.com/dgwnm39m7/video/upload/v1772444885/clipfly-ai-20260302144305_1_sygqaz.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          ) : (
            <img 
              src={fallbackImage}
              alt="Luxury Serviced Apartments in Centaurus Islamabad - Premium Accommodation with Panoramic Views"
              className="absolute top-1/2 left-1/2 min-w-full min-h-full w-auto h-auto transform -translate-x-1/2 -translate-y-1/2 object-cover"
            />
          )}

          {/* Dark Overlay - Improves text readability */}
          <div className="absolute inset-0 lg:bg-black/15 bg-black/50"></div>
        </div>

        {/* Content Overlay */}
        <div className="relative z-10 h-full flex items-center justify-center">
          <div className="container-custom text-center text-white">
            {/* Badge - SEO-friendly text */}
            <div className="animate-fade-in-up">
              <span className="inline-block text-white px-4 2xl:py-2 py-1 rounded-full text-[22px] md:text-xl 2xl:text-3xl font-bold">
                ✦ Premium Serviced Apartments in Centaurus Islamabad ✦
              </span>
            </div>

            {/* Main Heading - Proper H1 for SEO */}
            <h1 className="text-5xl md:text-7xl 2xl:text-8xl font-bold 2xl:mb-4 mb-2 animate-fade-in-up animation-delay-200">
              <span className="block">A serene escape in the</span>
              <span className="block text-[#c9a86c]">Heart of Islamabad</span>
            </h1>

            {/* Subheading - SEO-optimized description */}
            <p className="text-xl md:text-2xl 2xl:mb-10 mb-4 max-w-3xl mx-auto text-gray-200 animate-fade-in-up animation-delay-400">
              Experience 5-star elegance with fully furnished suites, private kitchens, 
              and breathtaking views of Islamabad & Faisal Mosque.
            </p>

            {/* Hidden SEO Text - Improves keyword density without affecting UX */}
            <div className="sr-only" aria-hidden="true">
              StayIN offers premium serviced apartments in Centaurus Hotel Islamabad. 
              Our luxury accommodations feature panoramic city views, 24/7 concierge service, 
              fully equipped kitchens, and easy access to Centaurus Mall. Perfect for business 
              travelers and families seeking serviced apartments in Islamabad's premier location.
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center animate-fade-in-up animation-delay-800">
              <Link 
                to="/apartments" 
                className="bg-[#c9a86c] text-white px-8 py-4 rounded-full font-medium hover:bg-[#b38f5a] transition-all duration-300 inline-flex items-center gap-2 justify-center group"
                aria-label="View our luxury serviced apartments in Centaurus Islamabad"
              >
                <span>View Our Luxury Apartments</span>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HeroSection;